import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function useResourceSlice(name: string) {
  const resources = useSelector((state: any) => state.resources);
  const [res, setRes] = useState<any>(null);
  useEffect(() => {
    if (name) {
      const res = resources[name];
      if (!res) {
        return;
      }
      setRes(res);
    }
  }, [resources, name]);

  return res;
}
